module.exports = __webpack_public_path__ + "static/media/16UNODC17.92ba612f.jpg";